import PropTypes from 'prop-types';
import React from 'react';
import { Link, Navigate } from 'react-router-dom';
// reactstrap components
import { Col, Row } from 'reactstrap';

import { getCurrentStudyProgram } from '../../../utils/getCurrentStudyProgram';
import { getSessionStorageItem } from '../../../utils/sessionStorage';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { STUDY_METHODS } from './constants/studyMethods';
import ModalMoreQuestions from './modalMoreQuestions';

class FlashcardComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentReceived: false,
      nextUpType: getSessionStorageItem('nextUpType'),
      nextUpItemIndex: Number(getSessionStorageItem('nextUpItem')),
      nextUpSectionIndex: Number(getSessionStorageItem('nextUpSection')),
      nextUpQualIndex: Number(getSessionStorageItem('qualIndex')),
      itemCheked: false,
      spId: null,
      sectionListName: null,
      itemListName: null,
      contentName: null,
      searchLink: {
        references: '?isChapterId',
        qualsAndCerts: '?isChapterId',
      },
      nextQuestionData: null,
      modalOpen: true,
      redirectTo: null,
    };
  }

  componentWillUnmount() {
    this.setState = {
      contentReceived: false,
      nextUpType: null,
      nextUpItemIndex: null,
      nextUpSectionIndex: null,
      itemCheked: false,
      spId: null,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !this.props?.chapterId &&
      !this.props?.isStudyFavoriteQuestion &&
      this.props?.isStudyFavoriteQuestion !== undefined &&
      !this.props?.isStudyingSubmittedQuestions &&
      this.props?.isStudyingSubmittedQuestions !== undefined &&
      !this.props?.isStudyingMyFavoriteQuestions &&
      this.props?.isStudyingMyFavoriteQuestions !== undefined &&
      !this.props?.isStudyingMySubmittedQuestions &&
      this.props?.isStudyingMySubmittedQuestions !== undefined
    ) {
      this.props.history('/app/study', { replace: true });
    }
    const loadingContent = nextProps.isLoadingContent;
    // get content type and fields
    if (
      !loadingContent &&
      nextProps.user?.id &&
      nextProps.pfeSktId &&
      !this.state.contentReceived &&
      this.state.nextUpType
    ) {
      let sectionListName = null;
      let itemListName = null;
      let contentName = null;
      if (this.state.nextUpType === 'references') {
        this.props.getContentByReference(
          getCurrentStudyProgram(nextProps.user.id, nextProps.pfeSktId),
        );
        sectionListName = 'references';
        itemListName = 'chapters';
        contentName = 'contentByReferences';
      }
      // if (this.state.nextUpType === 'qualsAndCerts') {
      //   this.props.getByWarfareQuals(nextProps.user.rate);
      //   sectionListName = 'references';
      //   itemListName = 'chapters';
      //   contentName = 'contentByQuals';
      // }
      this.setState({
        sectionListName,
        itemListName,
        contentName,
        contentReceived: true,
      });
    }

    // get next question data
    if (
      !nextProps.pfeSktIdWaiting &&
      this.state.contentReceived &&
      !loadingContent &&
      !this.state.itemCheked
    ) {
      let spId = null;
      let nextQuestionData = null;

      if (this.state.nextUpType === 'qualsAndCerts') {
        nextQuestionData = this.getNextUpItem(
          nextProps[this.state.contentName][this.state.nextUpQualIndex]
            ?.counters,
          nextProps[this.state.contentName][this.state.nextUpQualIndex][
            this.state.sectionListName
          ],
          this.state.itemListName,
        );
        spId =
          nextProps[this.state.contentName][this.state.nextUpQualIndex]
            .studyProgramId;
      } else {
        nextQuestionData = this.getNextUpItem(
          nextProps[this.state.contentName].counters,
          nextProps[this.state.contentName][this.state.sectionListName],
          this.state.itemListName,
        );

        if (nextProps[this.state.contentName].studyProgramId !== undefined) {
          spId = nextProps[this.state.contentName].studyProgramId;
        } else {
          spId = this.getStudyProgramFromUser(
            nextProps.user,
            nextProps.pfeSktId,
          );
        }
      }

      this.setState({
        nextQuestionData,
        spId,
        itemCheked: true,
      });
    }

    if (
      nextProps.messageResetChapter &&
      nextProps.messageResetChapter.text !== ''
    ) {
      this.hideMessage(this.props.resetChapterMessagge);
    }
  }

  hideMessage = (functionParam) => {
    setTimeout(() => {
      functionParam({ type: 'success', text: '' });
    }, 3000);
  };

  getStudyProgramFromUser = (user, rateId) => {
    if (user !== undefined) {
      if (user.studyPrograms !== undefined) {
        return getCurrentStudyProgram(user, rateId).id.toString();
      }
    }
    return 0;
  };

  getNextUpItem = (totalCounters, sectionList, itemListName) => {
    let nextItem = null;
    let itemList = [].concat.apply(
      [],
      sectionList.map((section) => section[itemListName]),
    );

    if (!Number(totalCounters?.learning) && !Number(totalCounters?.review)) {
      itemList = itemList.filter(
        (item) =>
          Number(item.new) || (item.counters && Number(item.counters.new)),
      );

      if (itemList.length > 0) {
        const rand = Math.floor(Math.random() * (itemList.length - 1));
        nextItem = itemList[rand];
      }
    } else {
      itemList = this.sortItemList(itemList);
      nextItem = itemList[0];
    }

    if (nextItem) {
      const sectionId =
        nextItem.reference !== undefined ? nextItem.reference : nextItem.topic;
      const sectionData = sectionList.find(
        (section) => sectionId === section.id,
      );

      return {
        nextUpItemName: `${sectionData.name} - ${nextItem.name}`,
        itemId: nextItem.id,
      };
    }
    return null;
  };

  sortItemList = (itemList) => {
    const orderedItemList = itemList.sort((a, b) => {
      let counterA;
      let counterB;
      if (a.counters) {
        counterA = Number(a.counters.learning);
        counterB = Number(b.counters.learning);
        if (counterA > counterB) {
          return -1;
        }
        if (counterA < counterB) {
          return 1;
        }
        counterA = Number(a.counters.review);
        counterB = Number(b.counters.review);
        if (counterA > counterB) {
          return -1;
        }
        if (counterA < counterB) {
          return 1;
        }
        return 0;
      }
      counterA = Number(a.learning);
      counterB = Number(b.learning);
      if (counterA > counterB) {
        return -1;
      }
      if (counterA < counterB) {
        return 1;
      }
      counterA = Number(a.review);
      counterB = Number(b.review);
      if (counterA > counterB) {
        return -1;
      }
      if (counterA < counterB) {
        return 1;
      }
      return 0;
    });
    return orderedItemList;
  };

  getReviewAgainPathname = () => {
    if (this.props.isStudyFavoriteQuestion)
      return '/app/question/studyFavoriteQuestion';
    if (this.props.isStudyingSubmittedQuestions)
      return '/app/question/studySubmittedQuestions';
    if (this.props.isStudyingMyFavoriteQuestions)
      return '/app/question/studyMyFavoriteQuestion';
    if (this.props.isStudyingMySubmittedQuestions)
      return '/app/question/studyMySubmittedQuestion';
    return `/app/question/${this.state.spId}/${this.props.chapterId}`;
  };

  handleReviewAgain = (reviewAgain) => {
    this.setState({
      contentReceived: false,
      itemCheked: false,
      nextQuestionData: null,
      redirectTo: reviewAgain,
    });

    if (this.props.isStudyFavoriteQuestion) {
      this.handleResetChapter(this.props.user.id, null, STUDY_METHODS.FAVORITE);
    } else if (this.props.isStudyingSubmittedQuestions) {
      this.handleResetChapter(this.props.user.id, null, STUDY_METHODS.SUBMIT);
    } else if (this.props.isStudyingMyFavoriteQuestions) {
      this.handleResetChapter(
        this.props.user.id,
        null,
        STUDY_METHODS.MY_FAVORITE,
      );
    } else if (this.props.isStudyingMySubmittedQuestions) {
      this.handleResetChapter(
        this.props.user.id,
        null,
        STUDY_METHODS.MY_SUBMIT,
      );
    } else {
      this.handleResetChapter(this.props.user.id, this.props.chapterId);
    }
  };

  handleResetChapter = (userId, chapterId, method = '') => {
    if (method) {
      this.props.resetChapter({ userId, chapterId: null, method });
    } else {
      this.props.resetChapter({ userId, chapterId, method: null });
    }
  };

  render() {
    if (this.state.redirectTo) {
      return <Navigate to={this.state.redirectTo} replace />;
    }
    let isLastSection = false;

    if (this.state.contentName && this.state.sectionListName) {
      isLastSection =
        this.state.nextUpSectionIndex >=
        this.props[this.state.contentName]?.[this.state.sectionListName]
          ?.length;
    }

    const isNotSpecialStudyMethod =
      !this.props.isStudyFavoriteQuestion &&
      !this.props.isStudyingSubmittedQuestions &&
      !this.props.isStudyingMyFavoriteQuestions &&
      !this.props.isStudyingMySubmittedQuestions;

    const reviewAgain = {
      pathname: this.getReviewAgainPathname(),
      studyProgramId: isNotSpecialStudyMethod ? this.state.spId : '',
      id:
        isNotSpecialStudyMethod && !!this.state.nextQuestionData
          ? this.state.nextQuestionData.itemId
          : '',
      search: isNotSpecialStudyMethod
        ? `${this.state.searchLink[this.state.nextUpType]}&sp=${this.state.spId}&id=${this.props.chapterId}`
        : '',
    };

    return (
      <div className="text-center">
        {!this.props.isLoadingContent && this.state.contentReceived ? (
          <div className="flashcard-complete-body-style">
            <div>
              <Row className="last-row-title-flashcard-complete align-items-center justify-content-center mx-0">
                <div className="gray-divider" />
                <div className="next-up-title mr-4 ml-4">Next Up</div>{' '}
                <div className="gray-divider" />
              </Row>

              <Row className="last-row-options-flashcard-complete align-items-center justify-content-center mt-4">
                <Col
                  md={4}
                  className="flashcard-complete-option-cols d-flex align-items-center justify-content-center flex-column"
                >
                  <div>
                    <div className="text-center">
                      <h5 className="mt-1">
                        Would you like to review again the questions?
                      </h5>
                      <p className="p-review">
                        Please note that &ldquo;review again&rdquo; does not add
                        up to points.
                      </p>
                      <div>
                        <Link
                          to={{
                            pathname: `/app/study`,
                          }}
                          className="btn btn-return btn-outline-secondary rounded-lg launch-btn mt-2"
                          role="button"
                          data-bs-toggle="button"
                        >
                          Return
                        </Link>
                        <button
                          onClick={() => this.handleReviewAgain(reviewAgain)}
                          className="btn btn-outline-secondary rounded-lg launch-btn mt-2 mr-2"
                        >
                          Review again
                        </button>
                      </div>
                      {this.props.messageResetChapter.text !== '' &&
                        this.props.messageResetChapter.type === 'error' && (
                          <div className="reviewMessageError message-error">
                            * {this.props.messageResetChapter.text}
                          </div>
                        )}
                    </div>
                    <br />
                    {this.state.nextQuestionData && !isLastSection && (
                      <div className="text-center">
                        <div className="text-center">
                          {this.state.nextQuestionData.nextUpItemName}
                        </div>
                        <Link
                          to={{
                            pathname: `/app/question/${this.state.spId}/${this.state.nextQuestionData.itemId}`,
                            studyProgramId: this.state.spId,
                            id: this.state.nextQuestionData.itemId,
                            search: `${
                              this.state.searchLink[this.state.nextUpType]
                            }&sp=${this.state.spId}&id=${
                              this.state.nextQuestionData.itemId
                            }`,
                          }}
                          className="btn btn-outline-secondary rounded-lg launch-btn mt-3 ml-1"
                        >
                          Launch
                        </Link>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <CircularLoading />
        )}
        <ModalMoreQuestions
          isOpen={this.props.moreQuestions && this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
          userSetting={this.props.user.userSetting}
          setFlashSectionChoose={this.props.setFlashSectionChoose}
        />
      </div>
    );
  }
}

FlashcardComplete.propTypes = {
  // objects given by the container
  avaiableQuestionTime: PropTypes.number,
  earnedPoints: PropTypes.number,
  scorePercentage: PropTypes.number,
  peerAverage: PropTypes.number,
  nextUp: PropTypes.array,
};

export default FlashcardComplete;
